'use strict';

import template from './create_trip_banner.html';

export default {
  bindings: {
    location: '<',
  },
  template: template,
};



// WEBPACK FOOTER //
// ./app/src/components/trips/create_trip_banner/create_trip_banner.js